import { render, staticRenderFns } from "./PolizasSACard.vue?vue&type=template&id=99871ae6&scoped=true&"
import script from "./PolizasSACard.vue?vue&type=script&lang=js&"
export * from "./PolizasSACard.vue?vue&type=script&lang=js&"
import style0 from "./PolizasSACard.vue?vue&type=style&index=0&id=99871ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99871ae6",
  null
  
)

export default component.exports